// src/Hooks/Whatsapp/WhatsappHook.jsx
import { useTenant } from '../../Common/Contexts/TenantContext'; // Make sure this path is correct

export const useWhatsappFloating = () => {
    const { tenantData } = useTenant();
    
    // Get phone number from TenantContext branding data
    const phoneArray = tenantData?.branding?.whatsapp;
    const rawNumber = Array.isArray(phoneArray) ? phoneArray[0] : (phoneArray || "");
    const companyName = tenantData?.branding?.brandName || "your agency";

    // Clean number: keep only digits
    const cleanNumber = rawNumber ? rawNumber.toString().replace(/[^0-9]/g, '') : "";

    // IMPORTANT: Use the official wa.me link
    const whatsappUrl = cleanNumber 
        ? `https://wa.me/${cleanNumber}?text=${encodeURIComponent(`Hello ${companyName}, I saw your website and would like to know more about your Services.`)}` 
        : "";

    return {
        whatsappUrl,
        isAvailable: !!cleanNumber
    };
};